var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data,"pagination":_vm.pagination,"scroll":{ y: 400 },"loading":_vm.loading},on:{"change":_vm.changeTableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }